import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import { Component, Output, Input, EventEmitter } from '@angular/core';
import { Observable }        from 'rxjs/Observable';
import { Subject }           from 'rxjs/Subject';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import {MdIconModule} from '@angular/material';

import 'rxjs/add/observable/of';
// Observable operators
import 'rxjs/add/operator/catch';
import swal from 'sweetalert2';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { NgxPageSize, NgxRefresh, NgxToggleColumn } from '../../shared/index';
import { CommonService, ClientWalkInService } from '../../services/index';
import { ClientWalkInModel } from '../../model/index';
import { AddEditClientComponent } from '../master/client/addEditClient.component';
import { AddEditphClientComponent } from '../master/phClient/addEditphClient.component';
import { SpareClientComponent } from './spareClient.component';

@Component({
    selector: 'client-search',
    templateUrl: './clientSearch.component.html',
    // styles: [`
    //   md-card-title,
    //   md-card-content {
    //     display: flex;
    //     justify-content: center;
    //   }
    //
    //   input {
    //     width: 300px;
    //   }
    //
    //   md-card-spinner {
    //     padding-left: 60px; // Make room for the spinner
    //   }
    //
    //   md-spinner {
    //     width: 30px;
    //     height: 30px;
    //     position: relative;
    //     top: 10px;
    //     left: 10px;
    //     opacity: 0.0;
    //   }
    //
    //   md-spinner.show {
    //     opacity: 1.0;
    //   }
    // `]
})
export class ClientSearchComponent {

    public pageType: string;
    @Input() query = '';
    @Input() searching = false;
    
    _params: any[] = [];
    //@Input() fromPage;
    @Input() set initialLoad(val: boolean) {
        this.iniLoadFn(val);
    }
    @Output() clientSearchEmit = new EventEmitter();
    //@Output() search = new EventEmitter<string>();
    private searchTerms = new Subject<string>();

    @Input() set params(val: any[]) {
        this._params = val;
        //this.setPageData();
    }

    searchVal = '';
    private type: string ='';
    private addBtnText: string = 'NEW CLIENT';
    columns = [];
    //toggleCol= [];
    //gridClientList: Observable<ClientWalkInModel[]>;
    filteredItems: Observable<ClientWalkInModel[]>;

    gridList = [];
    searchTerm$ = new Subject<string>();

    page = {
        limit: 50,
        count: 10,
        offset: 0,
        orderBy: 'client_id',
        orderDir: 'desc',
        query: '',
        type: ''
    };
    bsModalRef: BsModalRef;

  //   folders = [
  //   {
  //     name: 'Photos',
  //     updated: new Date('1/1/16'),
  //   },
  //   {
  //     name: 'Recipes',
  //     updated: new Date('1/17/16'),
  //   },
  //   {
  //     name: 'Work',
  //     updated: new Date('1/28/16'),
  //   }
  // ];

    constructor(private commonService: CommonService, private modalService: BsModalService) {
        this.loadClientListGrid();
    }

    ngOnInit(): void {
        this.columns = [
            { name: 'Client ID', prop: 'client_no', width: 100, maxWidth: 120, toggle: true },
            { name: 'Name', prop: 'client_name', maxWidth: 150 },
            { name: 'D.O.B', prop: 'disp_dob', maxWidth: 100 },
            { name: 'Age', prop: 'age', maxWidth: 60 },
            { name: 'Address', prop: 'address', maxWidth: 150 },
            { name: 'Area', prop: 'area', maxWidth: 150 },
            { name: 'City', prop: 'city', maxWidth: 100 },
            { name: 'Mobile', prop: 'mobile', maxWidth: 115 }
        ];
        setTimeout(() => {
          $('#clientSearch').focus();
        }, 100);
        //this.toggleCol = Object.assign({}, this.columns);
    }
    iniLoadFn(initialLoad) {
        if (initialLoad == true) {
            this.searchTerm$.next('');
        }
    }
    loadClientListGrid() {
        let that = this;

        //this.searchTerm$
        this.commonService.search(this.searchTerm$, this.page)
            .subscribe(results => {
                that.gridList = results.data;
                that.page.count = results.totCnt;
            });
    }
    // loadClientList(query: string) {
    //     let that = this;
    //
    //     // data = {
    //     //     query: query
    //     // };
    //     this.page.query = query;
    //
    //     // this.gridClientList = this.searchTerms
    //     //     .debounceTime(300)        // wait 300ms after each keystroke before considering the term
    //     //     .distinctUntilChanged()   // ignore if next search term is same as previous
    //     //     .switchMap(query => query   // switch to new observable each time the term changes
    //     //         // return the http search observable
    //     //         ? this.trtrrt()
    //     //
    //     //         // or the observable of empty heroes if there was no search term
    //     //         : Observable.of<ClientWalkInModel[]>([]))
    //     //     .catch(error => {
    //     //         // TODO: add real error handling
    //     //         console.log(error);
    //     //         return [];
    //     //     });
    //
    //     that.commonService
    //         .loadClientGridList(this.page)
    //         .then(function(res: any) {
    //             //that.clientList = res;
    //             that.gridClientList = res.data;
    //             that.page.count = res.totCnt;
    //             //that.clientCtrl.setValue(that.clientInData['client_id']);
    //             // if (that.mode == "Edit") {
    //             //     that.skuCtrl.disable();
    //             //     $('#sku_gms').focus();
    //             // }
    //         });
    //
    //
    //
    // }
    // trtrrt() {
    //     let that = this,
    //         data = {
    //             query: query
    //         };
    //
    //         that.commonService
    //             .loadClientListTest(data)
    //             .then(function(res: any) {
    //                 //that.clientList = res;
    //                 that.gridClientList = res.data;
    //                 that.page.count = res.totCnt;
    //                 //that.clientCtrl.setValue(that.clientInData['client_id']);
    //                 // if (that.mode == "Edit") {
    //                 //     that.skuCtrl.disable();
    //                 //     $('#sku_gms').focus();
    //                 // }
    //             });
    // }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.loadClientListGrid();
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.loadClientListGrid();
    }
    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }
    setType(type: string){
        this.type=type;
        this.page.type = type;

        switch (type) {
            // case 'SG Promo':
            //     this.addBtnText = 'NEW CLIENT';
            //     break;
            // case 'DR Promo':
            //     this.addBtnText = 'NEW CLIENT';
            //     break;
            case 'HV Appointment':
                this.addBtnText = 'SPOT HV';
                break;
            case 'SOA Appointment':
                this.addBtnText = 'SPOT SOA';
                break;
            case 'Spare Bill':
                this.addBtnText = 'SPARE CLIENT';
                break;
            case 'Phone Tracking':
                this.addBtnText = 'NEW PH CLIENT';
                break;
            default: 
                this.addBtnText = 'NEW CLIENT';
                break;
        }
    }
    search(query: string) {
        //debugger;//this.store.dispatch(new book.SearchAction(query));
        //this.loadClientList(query);
        //this.page.offset = pageInfo.offset;

        //this.searchTerms.next(query);
    }
  /*  bsModalRef: BsModalRef;

    onclickNewClient(row: object) {
        let that = this;
     
        row = {
            ref_id: '',
            mode: 'Add'
        };
     
        this.bsModalRef = this.modalService.show(AddEditClientComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg maxWidthPer-80'
        });
        this.bsModalRef.content.title = 'Add Client Details';
        //this.bsModalRef.content.mode = mode;
        this.bsModalRef.content.clientdata = Object.assign({}, row);
        this.bsModalRef.content.clientUpdateEvent.subscribe(($e) => {
            that.searchTerm$.next($e['client_no']);
        });
       
    }*/
    
    public onclickNewClient(mode: string, row: any): void {
        let that = this,
            pageType = this.type;
              
      //  row['page_from'] = pageType;
        if (pageType == 'Client Walk-in') {

            row = {
            ref_id: '',
            mode: 'Add'
        };
            
            this.bsModalRef = this.modalService.show(AddEditClientComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg compWidth-90'
            });


            this.bsModalRef.content.clientdata = Object.assign({}, row);
        } else if (pageType == 'SG Promo') {

            row = {
            ref_id: '',
            mode: 'Add'
        };
            
            this.bsModalRef = this.modalService.show(AddEditClientComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg compWidth-90'
            });


            this.bsModalRef.content.clientdata = Object.assign({}, row);
        } else if (pageType == 'DR Promo') {

            row = {
                ref_id: '',
                mode: 'Add'
            };

            this.bsModalRef = this.modalService.show(AddEditClientComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg compWidth-90'
            });


            this.bsModalRef.content.clientdata = Object.assign({}, row);
        } else if (pageType == 'Store Promo') {

            row = {
                ref_id: '',
                mode: 'Add'
            };

            this.bsModalRef = this.modalService.show(AddEditClientComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg compWidth-90'
            });

            this.bsModalRef.content.clientdata = Object.assign({}, row);
        } else if (pageType == 'HV Entry' || pageType == 'SOA Entry') {
            row = {
                ref_id: '',
                mode: 'Add'
            };
            this.bsModalRef = this.modalService.show(AddEditClientComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg compWidth-90'
            });
            this.bsModalRef.content.clientdata = Object.assign({}, row);
        } else if (pageType == 'Phone Tracking' || pageType == 'HV Appointment' || pageType == 'SOA Appointment') {
            row = {
                ref_id: '',
                mode: 'Add'
            };
            this.bsModalRef = this.modalService.show(AddEditphClientComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg compWidth-90'
            });
            this.bsModalRef.content.clientdata = Object.assign({}, row);
        }  else if (pageType == 'Spare Bill') {
            this.bsModalRef = this.modalService.show(SpareClientComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg compWidth-40'
            });
        }
         
        this.bsModalRef.content.title =' Add ' + pageType + ' Details';
        this.bsModalRef.content.clientUpdateEvent.subscribe(($e) => {
            that.searchTerm$.next($e['client_no']);
        });
    }

    onSelectCustomer($event, row){
        let feedback = row.sold_feedback;
        if(feedback == 'Not-Satisfied'){   
         swal('NOT STATISFIED CLIENT','Please Take More Care!..');
        }
        $('.client-search-list a').removeClass('active');
        $event.currentTarget.classList.add('active');

        this.clientSearchEmit.emit(row);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/common/clientSearch.component.ts